import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './PaymentSuccess.css';

const MembershipPaymentResult = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const order = searchParams.get('order');
  const errorMessage = searchParams.get('message');

  const variant = pathname.endsWith('/payment-refunded')
    ? 'refunded'
    : pathname.endsWith('/payment-error')
      ? 'error'
      : 'success';

  // On successful payment, redirect straight to the membership profile page.
  useEffect(() => {
    if (variant === 'success') {
      window.location.replace('https://kikisexperience.com/profile');
    }
  }, [variant]);

  const config = {
    success: {
      cardClass: 'success-card',
      iconClass: 'success-icon',
      icon: 'bi-shield-check',
      title: 'Payment Pre-Authorized',
      message: (
        <>
          Your card has been pre-authorized — no charge has been made yet.{' '}
          <strong>Our team will review your application and capture the payment once approved.</strong>{' '}
          You will receive an email confirmation as soon as your membership is activated.
        </>
      ),
      detailLabel: order ? `Order #${order}` : null,
    },
    refunded: {
      cardClass: 'pending-card',
      iconClass: 'pending-icon',
      icon: 'bi-arrow-counterclockwise',
      title: 'Payment Refunded',
      message:
        'Your payment has been refunded. If you did not request a refund, please contact support.',
      detailLabel: order ? `Order #${order}` : null,
    },
    error: {
      cardClass: 'error-card',
      iconClass: 'error-icon',
      icon: 'bi-exclamation-triangle-fill',
      title: 'Payment Failed',
      message:
        errorMessage ||
        'We could not process your payment. Please try again or contact support.',
      detailLabel: null,
    },
  }[variant];

  // Successful payments are redirected away in the effect above; render nothing
  // so the pre-authorized card never flashes before the redirect happens.
  if (variant === 'success') {
    return null;
  }

  return (
    <>
      <Navbar />
      <div className="payment-success-container">
        <div className={`status-card ${config.cardClass}`}>
          <div className={`status-icon ${config.iconClass}`}>
            <i className={`bi ${config.icon}`}></i>
          </div>
          <h2>{config.title}</h2>
          <p>{config.message}</p>

          {config.detailLabel && (
            <div className="confirmation-message">
              <i className="bi bi-hash me-2"></i>
              {config.detailLabel}
            </div>
          )}

          <div className="action-buttons">
            {variant === 'success' ? (
              <a className="btn-primary-action" href="https://kikisexperiences.com/profile">
                <i className="bi bi-person-badge me-2"></i>
                View My Membership
              </a>
            ) : (
              <button className="btn-secondary-action" onClick={() => navigate('/')}>
                <i className="bi bi-house me-2"></i>
                Back to Home
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MembershipPaymentResult;
